export const desktopTheme = {
  colors: {
    elevation1: '#323232',
    elevation2: '#242424',
    elevation3: '#1D1D1D',
    accent1: '#33A7FF',
    accent2: '#2475B2',
    accent3: '#3C93FF',
    highlight1: '#FFFFFF',
    highlight2: '#AAAAAA',
    highlight3: '#F1F1F1',
  },
  fontSizes: {
    root: '12px',
  },
  sizes: {
    rootWidth: '360px',
    rowHeight: '26px',
    folderTitleHeight: '26px',
  },
  fonts: {
    mono: 'Inter',
    sans: 'Inter',
  },
};

export const mobileTheme = {
  colors: {
    elevation1: '#323232AA',
    elevation2: '#24242400',
    elevation3: '#1D1D1D',
    accent1: '#33A7FF',
    accent2: '#2475B2',
    accent3: '#3C93FF',
    highlight1: '#FFFFFF',
    highlight2: '#AAAAAA',
    highlight3: '#F1F1F1',
  },
  fontSizes: {
    root: '12px',
  },
  sizes: {
    rootWidth: '360px',
    rowHeight: '26px',
    folderTitleHeight: '26px',
    controlWidth: '140px',
  },
  fonts: {
    mono: 'Inter',
    sans: 'Inter',
  },
  borderWidths: {
    folder: '0px',
  },
  space: {
    rowGap: '11px',
  },
};
